import { Component, ComponentRef, Type, ViewChild, ViewContainerRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AutocompleteDropdownComponent } from "../../../autocomplete-dropdown/autocomplete-dropdown.component";
import { ReactiveFormsModule } from "@angular/forms";
import { JobOrderInventoryDetails } from "../../../../models/job-orders.interface";
import { LoadingService } from "../../../../services/loading.service";
import { Stats } from "../../../../models/stats.interface";
import { getTallyTypeByJobOrderType, TallyType } from "../../../../constants/operations-contsants";
import { StatsService } from "../../../../services/stats.service";
import { PageCloseButtonComponent } from "../../../common/close-button/page-close-button.component";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { NoDataFoundComponent } from "../../../no-data-found/no-data-found.component";

@Component({
  selector: "app-manage-tally",
  standalone: true,
  imports: [
    AutocompleteDropdownComponent,
    ReactiveFormsModule,
    PageCloseButtonComponent,
    NoDataFoundComponent,
    NoDataComponent
  ],
  templateUrl: "./manage-tally.component.html",
  styleUrl: "./manage-tally.component.scss"
})
export class ManageTallyComponent {
  readOnlyMode: boolean = false;
  editingEnabled: boolean = false;
  addNewMode: boolean = false;
  jobOrderInventoryDetails!: JobOrderInventoryDetails;
  tallyType: TallyType | undefined;
  jobOrderStats: Stats[] = [];

  @ViewChild("jobOrderInventorySearch") jobOrderInventorySearch!: AutocompleteDropdownComponent;
  @ViewChild("tallyRenderer", { read: ViewContainerRef, static: true }) tallyRenderer!: ViewContainerRef;
  tallyComponentRef!: ComponentRef<any>;

  constructor(private router: Router,
              private loadingService: LoadingService,
              public route:ActivatedRoute,
              private statsService: StatsService) {
  }

  ngOnInit(){
    const path = this.route.snapshot?.url[0]?.path;
    switch (path) {
      case "add-new":
        this.addNewMode = true;
        this.readOnlyMode = false;
        this.editingEnabled = false;
        break;
      case "edit":
        this.editingEnabled = true;
        this.readOnlyMode = false;
        this.addNewMode = false;
        break;
      case "view":
        this.readOnlyMode = true;
        this.editingEnabled = false;
        this.addNewMode = false;
        break;
      default:
        this.addNewMode = true;
        this.readOnlyMode = false;
        this.editingEnabled = false;
        break;
    }
  }

  goBack() {
    if (!this.tallyComponentRef) {
      this.router.navigateByUrl("/manage-operations/import/tally");
    }
    this.tallyComponentRef.instance.cancel();
  }


  submitForm() {
    if (!this.tallyComponentRef)
      return;
    this.tallyComponentRef.instance.save();
  }

  jobOrderSelected(selectedJobOrder: JobOrderInventoryDetails) {
    this.loadingService.show();
    this.jobOrderInventorySearch.searchTerm = "";

  /*  if (this.jobOrderInventoryDetails?.jobOrderId === selectedJobOrder?.jobOrderId) // if same job order is selected again
      return;*/

    console.log("#selectedJO", selectedJobOrder);
    this.jobOrderInventoryDetails = selectedJobOrder;
    this.tallyType = getTallyTypeByJobOrderType(this.jobOrderInventoryDetails?.jobOrderType);
    this.jobOrderStats = this.statsService.createJobOrderStats(selectedJobOrder);
    this.loadComponent()
    this.loadingService.hide()
  }

  loadComponent() {
    this.tallyRenderer.clear();
    const componentType = this.resolveComponent();
    this.tallyComponentRef= this.tallyRenderer.createComponent(componentType);

    // Set Inputs
    this.tallyComponentRef.instance.jobOrderInventoryDetails = this.jobOrderInventoryDetails;
    this.tallyComponentRef.instance.jobOrderStats = this.jobOrderStats;
  }

  resolveComponent(): Type<any> {
    const tallyConfig: any = this.tallyType;

    if (!tallyConfig) {
      return NoDataComponent;
    }

    if ("getComponent" in tallyConfig) {
      return tallyConfig.getComponent(this.jobOrderInventoryDetails);
    }

    return tallyConfig.component;
  }
}
